import { DateTime as DateTime$1 } from "../../../../components/DateTime/index.js";
import { UserName } from "../../../Users/shared/UserName.js";
import { UserAvatar } from "../../../Users/shared/UserAvatar.js";
import { FilesListDisplay } from "../../../Files/shared/FilesListDisplay.js";
import { UserAndGroupNames as UsersAndGroups } from "../../../Users/shared/UserAndGroupNames.js";
import "react";
import { Label } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
// src/modules/Mail/components/MailMessageFullView/index.tsx
function MailMessageFullView({ body, ccUserAndGroups, fileUrls, receiverUserAndGroups, sender, sentAt, subject }) {
	return /* @__PURE__ */ jsxs("div", { children: [/* @__PURE__ */ jsxs("div", {
		className: "mt-xs flex font-medium",
		children: [
			sender && /* @__PURE__ */ jsx(UserAvatar, { user: sender }),
			/* @__PURE__ */ jsxs("div", {
				className: "ml-sm grow text-left",
				children: [
					sender && /* @__PURE__ */ jsx("h3", {
						className: "font-bold",
						children: /* @__PURE__ */ jsx(UserName, { user: sender || "" })
					}),
					Array.isArray(receiverUserAndGroups) && !!receiverUserAndGroups.length && /* @__PURE__ */ jsxs("p", {
						className: "text-sm",
						children: [
							/* @__PURE__ */ jsx(Label, { children: "To" }),
							" ",
							/* @__PURE__ */ jsx(UsersAndGroups, { usersAndGroups: receiverUserAndGroups })
						]
					}),
					!!ccUserAndGroups?.length && /* @__PURE__ */ jsxs("p", {
						className: "text-sm",
						children: [
							/* @__PURE__ */ jsx(Label, { children: "CC" }),
							" ",
							/* @__PURE__ */ jsx(UsersAndGroups, { usersAndGroups: ccUserAndGroups })
						]
					})
				]
			}),
			!!sentAt && /* @__PURE__ */ jsx("p", {
				className: "text-color-neutral text-sm",
				children: /* @__PURE__ */ jsx(DateTime$1, {
					timestamp: sentAt,
					relative: true
				})
			})
		]
	}), /* @__PURE__ */ jsxs("div", {
		className: "mt-base",
		children: [
			!!subject && /* @__PURE__ */ jsx("div", {
				className: "text-md font-bold",
				children: subject
			}),
			!!body && /* @__PURE__ */ jsx("article", { dangerouslySetInnerHTML: { __html: body } }),
			Array.isArray(fileUrls) && !!fileUrls.length && /* @__PURE__ */ jsx("div", {
				className: "mt-base",
				children: /* @__PURE__ */ jsx(FilesListDisplay, { fileUrls })
			})
		]
	})] });
}
export { MailMessageFullView };

//# sourceMappingURL=index.js.map